import { render } from "./manyStudentUpdateFace.vue?vue&type=template&id=96c66328&scoped=true"
import script from "./manyStudentUpdateFace.vue?vue&type=script&lang=js"
export * from "./manyStudentUpdateFace.vue?vue&type=script&lang=js"

import "./manyStudentUpdateFace.vue?vue&type=style&index=0&id=96c66328&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c66328"]])

export default __exports__